<template>
  <div id="calculator-block" class="calculator-block" ref="myDiv" itemscope itemtype="http://schema.org/WebPageElement">
    <v-notification>
    </v-notification>
    <div class="container">
      <h2 class="tm-section__title calculator-block__title" itemprop="headline">{{ getLocalization('Calculator') }}</h2>
      <div class="calculator-block__message"  itemprop="potentialAction" itemscope itemtype="http://schema.org/SearchAction"
           v-html="getLocalization('Set the parameters in the calculator to estimate your future income')">
      </div>
      <div class="calculator-block__content">
        <div class="--left">
          <div class="input-wrapper">
            <label>{{getLocalization('Country')}}</label>
            <multiselect
                v-model="selectedCountry"
                :placeholder="getLocalization('Select country')"
                label="title"
                track-by="id"
                :closeOnSelect="true"
                @select="selectCountry"
                :group-select="true"
                :showLabels="false"
                :options="countryLabels"
                :option-height="40"
                :multiple="false"
            >
              <template slot="option" slot-scope="props">
                <img :src="props.option.img_path">
                <span>{{ props.option.title }}</span>
              </template>
            </multiselect>
          </div>
          <div class="input-wrapper">
            <label>{{getLocalization('Port count')}}</label>
            <input type="text"
                   min="8"
                   max="2048"
                   oninput="if (/[^0-9]/.test(this.value)) { this.value = this.value.replace(/[^0-9]/g, '') + ''; } else { this.value += ''; } this.selectionStart = this.selectionEnd = this.value.search(/[^\d\s]/);"
                   v-model="portCounts"
                   :placeholder="getLocalization('Minimum 8')"
                   class="input">
          </div>
          <div class="input-wrapper">
            <label>{{getLocalization('SIM CARD PRICE')}}</label>
            <input type="text"
                   v-model="simCardsPrice"
                   :placeholder="getLocalization('SIM CARD PRICE')"
                   class="input"
                   onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                   oninput="if (/[^0-9]/.test(this.value)) { this.value = this.value.replace(/[^0-9]/g, '') + '₽'; } else { this.value += ' ₽'; } this.selectionStart = this.selectionEnd = this.value.search(/[^\d\s]/);"
            >
          </div>
          <div class="calculator-block__submit">
            <button @click="calculateResult()" class="button orange form-btn" itemprop="potentialAction">
              <img src="/img/svg/calculator/calc-icon.svg"/>
              {{getLocalization('Count an income')}}
            </button>
          </div>
        </div>
        <div class="--right" itemprop="result" itemscope itemtype="http://schema.org/PriceSpecification">
          <div class="calculator-round">
            <div
                class="calculator-round__percent"
                :style="`--percent-val: ${resultPercent}%`"
            >
              <div class="calculator-round__content">
                <template v-if="resultPercent > 0">
                  <div class="calculator-round__calc-info">
                    <div class="--percent">{{ resultPercent }}</div>
                    <div class="--divider"></div>
                    <div class="--title">{{getLocalization('Profit')}}, %</div>
                    <div class="--info">
                      {{getLocalization('Profit for 3 month')}} <div>{{ profitForThreeMonth }} ₽</div>
                    </div>
                    <div class="--divider"></div>
                    <div class="--info">
                      {{getLocalization('Profit for 6 month')}} <div>{{ profitForSixMonth }} ₽</div>
                    </div>
                    <div class="--divider"></div>
                    <div class="--info">
                      {{getLocalization('Profit for a year')}} <div>{{ profitForYear }} ₽</div>
                    </div>
                    <div class="--divider"></div>
                  </div>
                </template>
                <template v-if="resultPercent <= 0">
                  <img src="/img/svg/calculator/calculator.png"/>
                  <span v-html="getLocalization('Here will be the result fill out the form')"></span>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="calculator-block__submit --mobile">
          <button class="button orange form-btn" @click="calculateResult()" itemprop="potentialAction">
            <img src="/img/svg/calculator/calc-icon.svg"/>
            Рассчитать прибыль
          </button>
        </div>
      </div>
    </div>
  </div>
<!--          <span class="span-result" v-if="!showResult" v-html="getLocalization('Here will be the result fill out the form')"></span>-->
<!--            <span v-html="profitLabelText" itemprop="priceCurrency" content="RUB"></span>-->
</template>

<script>
import BaseAdminMixin from "../../../admin/components/mixins/BaseAdminMixin";
import Multiselect from "vue-multiselect";
import Modal from "../../../components/table/modal";
export default {
  name: "calculator",
  mixins: [
    BaseAdminMixin
  ],
  components: {
    Multiselect,
    Modal,
  },
  mounted() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.isScrolledToCalculator = true;
        }
      });
    });
    observer.observe(this.$refs.myDiv);
  },
  data: function () {
    return {
      selectedCountriesToAdd: [],
      isScrolledToCalculator: false,
      showResult: false,
      portCounts: '',
      profitLabelText: '',
      simCardsPrice: '',
      selectedCountry: [],
      selectedService: [],
      countryLabels: [],
      selectedServiceId: '',
      selectedCountryId: '',
      serviceVariationPrices: [],
      resultPercent: 0,
      profitForThreeMonth: 0,
      profitForSixMonth: 0,
      profitForYear: 0,
    }
  },
  methods: {
    async getCalculatorData() {
      let countriesResponse = await this.sendRequest('/calculator/getcountries');
      if (countriesResponse?.status === 'ok') {
        let countries = countriesResponse['data'];
        countries.forEach(el => el.title = this.getLocalization(el.title));
        this.countryLabels = countries;
      }
    },
    async calculateResult(){
      let selectedCountry = this.selectedCountryId;
      let countPorts = this.portCounts;
      let simPrice = this.simCardsPrice;

      let isValidated = await this.validateInputs();
      if(isValidated){
        let response = await this.sendRequest('/calculator/getCalculatorProfit', 'post',{selectedCountry,countPorts, simPrice});
        if(response['status'] === 'ok'){
          this.profitForThreeMonth = response['data']['profit_for_3_month'];
          this.profitForSixMonth = response['data']['profit_for_6_month'];
          this.profitForYear = response['data']['profit_for_a_year'];
          this.resultPercent = response['data']['percent'];
        }
      }
    },
    async validateInputs(){
      if(!this.selectedCountryId){
        await this.alertMessage(this.getLocalization('Choose the country'),'warn');
        return false;
      }
      if(!this.portCounts){
        await this.alertMessage(this.getLocalization('Fill the port counts'),'warn');
        return false;
      }
      if(!this.simCardsPrice){
        await this.alertMessage(this.getLocalization('Fill the sim card price'),'warn');
        return false;
      }
      return true;
    },
    selectCountry(option){
      this.selectedCountryId = option.id
    },
  },
  watch: {
    async isScrolledToCalculator(isVisible) {
      if (isVisible) {
        await this.getCalculatorData();
      }
    },
    async portCounts(newValue) {
      let self = this;
      setTimeout(await function() {
        if (self.portCounts < 8) {
          self.portCounts = 8;
          self.alertMessage(this.getLocalization('Min counts of port is 8'),'warning')
        }
        if (self.portCounts > 2048) {
          self.portCounts = 2048;
          self.alertMessage(this.getLocalization('Max counts of port is 2048'),'warning')
        }
      }, 1000);
    },
  },
}
</script>
